import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import usePortfolioBalance from '../../../hooks/usePortfolioBalance';
import { formatAdminWithdrawalDetails } from '../../../utils/balanceUtils';

export default function UserWithdrawals(props) {
  const { withdrawals } = props;
  const { coinRates } = usePortfolioBalance();
  const getDate = (date) => new Date(date).toLocaleString();

  return (
    <div>
      {withdrawals && withdrawals.length > 0 && (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: '100%' }} size="small">
      <TableHead>
        <TableRow>
          <TableCell>USD</TableCell>
          <TableCell align="right">Coin amount</TableCell>
          <TableCell align="right">Rate</TableCell>
          <TableCell align="right">Coin</TableCell>
          <TableCell align="right">Address</TableCell>
          <TableCell align="right">Dest. tag</TableCell>
          <TableCell align="right">Status</TableCell>
          <TableCell align="right">Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {withdrawals.map((withdrawal) => {
          const d = formatAdminWithdrawalDetails(withdrawal, coinRates);
          return (
          <TableRow key={withdrawal.id}>
            <TableCell component="th" scope="row">{d.usd}</TableCell>
            <TableCell align="right">{d.coinUnits}</TableCell>
            <TableCell align="right" sx={{ fontSize: 12 }}>{d.rate}</TableCell>
            <TableCell align="right">{d.coin}</TableCell>
            <TableCell align="right" sx={{ fontSize: 11, maxWidth: 120, wordBreak: 'break-all' }}>
              {withdrawal.address}
            </TableCell>
            <TableCell align="right" sx={{ fontSize: 12 }}>
              {withdrawal.destination_tag || '—'}
            </TableCell>
            <TableCell align="right">{withdrawal.status}</TableCell>
            <TableCell align="right" sx={{ fontSize: 12 }}>{getDate(withdrawal.created_at)}</TableCell>
          </TableRow>
          );
        })}
      </TableBody>
    </Table>
    </TableContainer>
    )}
    </div>
  );
}
